// extracted by mini-css-extract-plugin
export default {"limited_edition_container":"limited_edition_container__3a2f4dfd","limited_edition_wrapper":"limited_edition_wrapper__3a2f4dfd","limited_edition":"limited_edition__3a2f4dfd"};